import { render, staticRenderFns } from "./AppDetailHeader.vue?vue&type=template&id=705bb362&scoped=true"
import script from "./AppDetailHeader.vue?vue&type=script&lang=js"
export * from "./AppDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./AppDetailHeader.vue?vue&type=style&index=0&id=705bb362&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705bb362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705bb362')) {
      api.createRecord('705bb362', component.options)
    } else {
      api.reload('705bb362', component.options)
    }
    module.hot.accept("./AppDetailHeader.vue?vue&type=template&id=705bb362&scoped=true", function () {
      api.rerender('705bb362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppDetailHeader/AppDetailHeader.vue"
export default component.exports